<template>
    <div ref="root">
        <div
            class="jobs__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="jobs__inner module__inner">
                <div class="jobs__inner--main module__inner--main">
                    <div
                        class="jobs__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle || module.data.text"
                    >
                        <div class="jobs__inner-col module__inner-col">
                            <div
                                class="jobs__header module__header"
                                v-bind:class="'bg-color module--color-' + module.appearance.color"
                            >
                                <app-modulebackground
                                    :module-id="module.id"
                                    custom-class="jobs__background module__background"
                                ></app-modulebackground>
                                <h2
                                    class="jobs__title module__title font-h2 color-h2"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="jobs__subtitle module__subtitle font-h3 color-h3"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                                <div
                                    class="jobs__text module__text font-p color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text"
                                    v-html="module.data.text"
                                ></div>
                                <div
                                    class="jobs__subnote module__text font-p font-small color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                >
                                    Ihre personenbezogenen Daten verarbeiten wir gemäß §&nbsp;26 Abs.&nbsp;1 S.&nbsp;1 BDSG bzw.
                                    Art.&nbsp;6 Abs.&nbsp;1 S.&nbsp;1 lit.&nbsp;b DSGVO zur Bearbeitung Ihrer Bewerbung. Weitere
                                    Informationen zu unserem Umgang mit personenbezogenen Daten, insbesondere zu Ihren Rechten
                                    als betroffene Person, finden Sie in unseren
                                    <router-link
                                        v-bind:to="getPrivacyLink"
                                        :target="getPrivacyTarget"
                                        :class="'font-bold module__link--underlined'"
                                        >Datenschutzinformationen für Bewerber</router-link
                                    >.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="jobs__inner-row module__inner-row">
                        <div class="jobs__inner-col module__inner-col">
                            <div
                                v-if="items && Array.isArray(items) && items.length > 0"
                                class="jobs__jobs-list module__list"
                            >
                                <div
                                    v-for="(items__value, items__key) in items"
                                    v-bind:key="items__value.id"
                                    :data-id="items__value.id"
                                    :data-preset-id="items__value.preset_id"
                                    :data-valid-from="items__value.data.valid_from"
                                    :data-valid-until="items__value.data.valid_until"
                                    class="jobs__job-single module__list-item check-visibility bg-color"
                                    :class="[
                                        {
                                            'module--color-1':
                                                (items__key % 2 !== 0 &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [1, 3].includes(parseInt(getActiveTheme)) &&
                                                    [2, 3, 4, 5, 6, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-2':
                                                (items__key % 2 !== 0 &&
                                                    [2].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [1, 3].includes(parseInt(getActiveTheme)) &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-3':
                                                (items__key % 2 !== 0 &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [4].includes(parseInt(getActiveTheme)) &&
                                                    [1, 2, 4, 5, 6, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-4':
                                                (items__key % 2 !== 0 &&
                                                    [4].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [4].includes(parseInt(getActiveTheme)) &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-5':
                                                items__key % 2 !== 0 &&
                                                [5].includes(parseInt(module.appearance.color)),
                                            'module--color-6':
                                                (items__key % 2 !== 0 &&
                                                    [6].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [2].includes(parseInt(getActiveTheme)) &&
                                                    [1, 2, 3, 4, 5, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-7':
                                                (items__key % 2 !== 0 &&
                                                    [7].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [2].includes(parseInt(getActiveTheme)) &&
                                                    [6].includes(parseInt(module.appearance.color)))
                                        }
                                    ]"
                                >
                                    <app-configbar
                                        v-if="editorMode"
                                        :show-data="true"
                                        :show-layout="false"
                                        :show-appearance="false"
                                        v-on:open="
                                            directEditListeditor({
                                                dataSource: 'deha.user.misc.jobs',
                                                listSubpage: 'Jobs',
                                                module_id: module.id,
                                                listitem_id: items__value.id
                                            })
                                        "
                                        inner
                                    ></app-configbar>

                                    <div
                                        class="jobs__job-details"
                                        v-bind:class="{
                                            container__boxed: [1, 3].includes(module.layout.type),
                                            'container__boxed flex--wrap': [2].includes(
                                                module.layout.type
                                            )
                                        }"
                                    >
                                        <div
                                            class="jobs__job-details-col--left"
                                            v-bind:class="{
                                                'col__width--half': [2].includes(module.layout.type)
                                            }"
                                        >
                                            <div
                                                class="jobs__job-header"
                                                v-if="
                                                    items__value.data.name ||
                                                        items__value.data.type ||
                                                        items__value.data.location ||
                                                        items__value.data.date
                                                "
                                            >
                                                <h3
                                                    v-if="items__value.data.name"
                                                    class="jobs__job-title font-h2 color-h2"
                                                >
                                                    {{ items__value.data.name }}
                                                </h3>

                                                <div
                                                    class="jobs__job-header-details flex--wrap color-p"
                                                    v-if="
                                                        items__value.data.type ||
                                                            items__value.data.location ||
                                                            items__value.data.date
                                                    "
                                                >
                                                    <div
                                                        class="jobs__job-header-details-item border-color-highlighted"
                                                        v-if="items__value.data.type"
                                                    >
                                                        {{ items__value.data.type }}
                                                    </div>
                                                    <div
                                                        class="jobs__job-header-details-item border-color-highlighted"
                                                        v-if="items__value.data.location"
                                                    >
                                                        {{ items__value.data.location }}
                                                    </div>
                                                    <div
                                                        class="jobs__job-header-details-item border-color-highlighted"
                                                        v-if="items__value.data.date"
                                                    >
                                                        {{ date(items__value.data.date) }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="jobs__job-body"
                                                v-bind:class="{
                                                    'flex--wrap': [1, 3].includes(
                                                        module.layout.type
                                                    )
                                                }"
                                                v-if="
                                                    items__value.data.tasks ||
                                                        items__value.data.offer ||
                                                        items__value.data.profile ||
                                                        items__value.data.contact_person
                                                "
                                            >
                                                <div
                                                    v-if="items__value.data.tasks"
                                                    class="jobs__job-body-row jobs__job-body-row--tasks"
                                                    v-bind:class="{
                                                        'col__width--half  flex--wrap': [
                                                            1
                                                        ].includes(module.layout.type),
                                                        'col__width--half flex--nowrap': [
                                                            3
                                                        ].includes(module.layout.type)
                                                    }"
                                                >
                                                    <div
                                                        class="jobs__teaser-box"
                                                        v-bind:class="{
                                                            'module__teaser-box--horizontal': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'module__teaser-box--vertical': [
                                                                3
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            class="jobs__job-body-row-icon module__icon"
                                                        >
                                                            <app-moduleicon
                                                                v-if="
                                                                    [3].includes(module.layout.type)
                                                                "
                                                                :data="{
                                                                    id: getRandomButDeterminedImageInNamespace(
                                                                        'icons/jobs/1'
                                                                    )
                                                                }"
                                                                :custom-class="
                                                                    'jobs__job-body-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                        </div>
                                                        <div
                                                            class="jobs__job-body-row-content module__teaser-box-text module__cms"
                                                        >
                                                            <h4
                                                                class="jobs__job-body-row-title font-bold font-h3 color-h3"
                                                            >
                                                                Was wir suchen
                                                            </h4>
                                                            <div
                                                                class="jobs__job-body-row-text color-p"
                                                                v-html="items__value.data.tasks"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    v-if="items__value.data.offer"
                                                    class="jobs__job-body-row jobs__job-body-row--offers"
                                                    v-bind:class="{
                                                        'col__width--half  flex--wrap': [
                                                            1
                                                        ].includes(module.layout.type),
                                                        'col__width--half flex--nowrap': [
                                                            3
                                                        ].includes(module.layout.type)
                                                    }"
                                                >
                                                    <div
                                                        class="jobs__teaser-box"
                                                        v-bind:class="{
                                                            'module__teaser-box--horizontal': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'module__teaser-box--vertical': [
                                                                3
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            class="jobs__job-body-row-icon module__icon"
                                                        >
                                                            <app-moduleicon
                                                                v-if="
                                                                    [3].includes(module.layout.type)
                                                                "
                                                                :data="{
                                                                    id: getRandomButDeterminedImageInNamespace(
                                                                        'icons/jobs/2'
                                                                    )
                                                                }"
                                                                :custom-class="
                                                                    'jobs__job-body-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                        </div>
                                                        <div
                                                            class="jobs__job-body-row-content module__teaser-box-text module__cms"
                                                        >
                                                            <h4
                                                                class="jobs__job-body-row-title font-bold font-h3 color-h3"
                                                            >
                                                                Was wir bieten
                                                            </h4>
                                                            <div
                                                                class="jobs__job-body-row-text color-p"
                                                                v-html="items__value.data.offer"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    v-if="items__value.data.profile"
                                                    class="jobs__job-body-row jobs__job-body-row--profiles"
                                                    v-bind:class="{
                                                        'col__width--half  flex--wrap': [
                                                            1
                                                        ].includes(module.layout.type),
                                                        'col__width--half flex--nowrap': [
                                                            3
                                                        ].includes(module.layout.type)
                                                    }"
                                                >
                                                    <div
                                                        class="jobs__teaser-box"
                                                        v-bind:class="{
                                                            'module__teaser-box--horizontal': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'module__teaser-box--vertical': [
                                                                3
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            class="jobs__job-body-row-icon module__icon"
                                                        >
                                                            <app-moduleicon
                                                                v-if="
                                                                    [3].includes(module.layout.type)
                                                                "
                                                                :data="{
                                                                    id: getRandomButDeterminedImageInNamespace(
                                                                        'icons/jobs/3'
                                                                    )
                                                                }"
                                                                :custom-class="
                                                                    'jobs__job-body-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                        </div>
                                                        <div
                                                            class="jobs__job-body-row-content module__teaser-box-text module__cms"
                                                        >
                                                            <h4
                                                                class="jobs__job-body-row-title font-bold font-h3 color-h3"
                                                            >
                                                                Ihr Profil
                                                            </h4>
                                                            <div
                                                                class="jobs__job-body-row-text color-p"
                                                                v-html="items__value.data.profile"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    v-if="items__value.data.contact_person"
                                                    class="jobs__job-body-row jobs__job-body-row--contact"
                                                    v-bind:class="{
                                                        'col__width--half  flex--wrap': [
                                                            1
                                                        ].includes(module.layout.type),
                                                        'col__width--half flex--nowrap': [
                                                            3
                                                        ].includes(module.layout.type)
                                                    }"
                                                >
                                                    <div
                                                        class="jobs__teaser-box"
                                                        v-bind:class="{
                                                            'module__teaser-box--horizontal': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'module__teaser-box--vertical': [
                                                                3
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            class="jobs__job-body-row-icon module__icon"
                                                        >
                                                            <app-moduleicon
                                                                v-if="
                                                                    [3].includes(module.layout.type)
                                                                "
                                                                :data="{
                                                                    id: getRandomButDeterminedImageInNamespace(
                                                                        'icons/jobs/4'
                                                                    )
                                                                }"
                                                                :custom-class="
                                                                    'jobs__job-body-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                        </div>
                                                        <div
                                                            class="jobs__job-body-row-content module__teaser-box-text module__cms"
                                                        >
                                                            <div
                                                                class="jobs__job-body-row-title font-bold font-h3 color-h3"
                                                            >
                                                                Ansprechpartner:
                                                                {{
                                                                    items__value.data.contact_person
                                                                }}
                                                            </div>

                                                            <div
                                                                class="color-p"
                                                                v-if="
                                                                    items__value.data
                                                                        .contact_forms !==
                                                                        undefined &&
                                                                        items__value.data
                                                                            .contact_forms !==
                                                                            null &&
                                                                        typeof items__value.data
                                                                            .contact_forms ===
                                                                            'object' &&
                                                                        Object.values(
                                                                            items__value.data
                                                                                .contact_forms
                                                                        ).includes('E-Mail') &&
                                                                        items__value.data.email
                                                                "
                                                            >
                                                                <span>E-Mail: </span>
                                                                <a
                                                                    :href="
                                                                        'mailto:' +
                                                                            items__value.data.email
                                                                    "
                                                                    >{{
                                                                        items__value.data.email
                                                                    }}</a
                                                                >
                                                            </div>

                                                            <div
                                                                class="color-p"
                                                                v-if="
                                                                    items__value.data
                                                                        .contact_forms !==
                                                                        undefined &&
                                                                        items__value.data
                                                                            .contact_forms !==
                                                                            null &&
                                                                        typeof items__value.data
                                                                            .contact_forms ===
                                                                            'object' &&
                                                                        Object.values(
                                                                            items__value.data
                                                                                .contact_forms
                                                                        ).includes('Telefon') &&
                                                                        items__value.data.phone
                                                                "
                                                            >
                                                                <span>Telefonnummer: </span>
                                                                <a
                                                                    :href="
                                                                        'tel:' +
                                                                            items__value.data.phone
                                                                    "
                                                                    >{{
                                                                        items__value.data.phone
                                                                    }}</a
                                                                >
                                                            </div>

                                                            <div
                                                                class="color-p"
                                                                v-if="
                                                                    items__value.data
                                                                        .contact_forms !==
                                                                        undefined &&
                                                                        items__value.data
                                                                            .contact_forms !==
                                                                            null &&
                                                                        typeof items__value.data
                                                                            .contact_forms ===
                                                                            'object' &&
                                                                        Object.values(
                                                                            items__value.data
                                                                                .contact_forms
                                                                        ).includes('Post') &&
                                                                        items__value.data.company
                                                                "
                                                            >
                                                                <span>Postanschrift:</span>
                                                                <div
                                                                    v-if="items__value.data.company"
                                                                >
                                                                    {{ items__value.data.company }}
                                                                </div>
                                                                <span
                                                                    v-if="
                                                                        items__value.data.address &&
                                                                            items__value.data
                                                                                .address.street
                                                                    "
                                                                >
                                                                    {{
                                                                        items__value.data.address
                                                                            .street
                                                                    }}
                                                                </span>
                                                                <br />
                                                                <span
                                                                    v-if="
                                                                        items__value.data.address &&
                                                                            items__value.data
                                                                                .address.zip
                                                                    "
                                                                >
                                                                    {{
                                                                        items__value.data.address
                                                                            .zip
                                                                    }}
                                                                </span>
                                                                <span
                                                                    v-if="
                                                                        items__value.data.address &&
                                                                            items__value.data
                                                                                .address.location
                                                                    "
                                                                >
                                                                    {{
                                                                        items__value.data.address
                                                                            .location
                                                                    }}
                                                                </span>
                                                                <br />
                                                                <span
                                                                    v-if="
                                                                        items__value.data.address &&
                                                                            items__value.data
                                                                                .address.country
                                                                    "
                                                                >
                                                                    {{
                                                                        items__value.data.address
                                                                            .country
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="jobs__job-details-col--right"
                                            v-bind:class="{
                                                'col__width--half': [2].includes(module.layout.type)
                                            }"
                                            v-if="
                                                items__value.data.image &&
                                                    [2].includes(module.layout.type)
                                            "
                                        >
                                            <a
                                                :href="
                                                    generateMediaUrl({
                                                        id: items__value.data.image.id
                                                    })
                                                "
                                                class="lightgallery"
                                                :data-lightgallery-group="
                                                    items__value.data.image.id
                                                "
                                            >
                                                <app-moduleimage
                                                    :data="items__value.data.image"
                                                    :tag="'div'"
                                                    :custom-class="'jobs__job-details-image'"
                                                ></app-moduleimage>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatGermanDate } from '@/helpers/utils';
import { mapActions, mapGetters } from 'vuex';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Configbar from '@/components/assorted/Configbar.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage,
        'app-moduleicon': ModuleIcon,
        'app-modulebackground': ModuleBackground,
        'app-configbar': Configbar
    },
    methods: {
        ...mapActions(['directEditListeditor']),
        date(date) {
            return formatGermanDate(date);
        }
    },
    computed: {
        ...mapGetters([
            'getListItems',
            'generateMediaUrl',
            'getRandomButDeterminedImageInNamespace',
            'editorMode',
            'getActiveTheme',
            'getPageUrlFromSlug'
        ]),
        getPrivacyLink() {
            return this.getPageUrlFromSlug('/datenschutz') || '';
        },
        getPrivacyTarget() {
            return this.editorMode ? '_self' : '_blank';
        },
        items() {
            let d_valid_from = new Date();
            d_valid_from.setHours(23);
            d_valid_from.setMinutes(59);
            let d_valid_until = new Date();
            d_valid_until.setHours(0);
            d_valid_until.setMinutes(0);
            return this.getListItems('deha.user.misc.jobs').filter(
                (i) =>
                    (!i.data ||
                        i.data.valid_from === undefined ||
                        i.data.valid_from === null ||
                        i.data.valid_from === '' ||
                        new Date(i.data.valid_from) <= d_valid_from) &&
                    (!i.data ||
                        i.data.valid_until === undefined ||
                        i.data.valid_until === null ||
                        i.data.valid_until === '' ||
                        new Date(i.data.valid_until) >= d_valid_until)
            );
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
